import { BrukerRoller } from '@klp/user/types';
import type { BrukerRolleFlagg } from '@klp/user/types';
import type { Portfolio } from './classes/Portfolio';

export type PortfolioRoleFilter = Array<BrukerRolleFlagg | BrukerRoller>;

/** The portfolios that have at least one of the roles, or all without roles. */
export const filterPortfolioList = (
    portfolioList: Array<Portfolio> | undefined,
    filter?: PortfolioRoleFilter,
): Array<Portfolio> => {
    if (!portfolioList) return [];
    if (!filter || filter.length === 0) return portfolioList;

    return portfolioList.filter((element) =>
        filter.some((role) =>
            role in BrukerRoller
                ? element.roller.some((r) => r.rolle === (role as BrukerRoller))
                : element[role as BrukerRolleFlagg],
        ),
    );
};
